import { render } from "./Forbidden.vue?vue&type=template&id=16e64022&scoped=true&ts=true"
import script from "./Forbidden.vue?vue&type=script&lang=ts"
export * from "./Forbidden.vue?vue&type=script&lang=ts"

import "./Forbidden.vue?vue&type=style&index=0&id=16e64022&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e64022"]])

export default __exports__